import { LoadingButton } from '@mui/lab';
import { styled } from '@mui/material';

export const MonochromeButton = styled(LoadingButton)(
  ({ selected, isPhone }: { selected?: boolean; isPhone?: boolean }) => ({
    paddingLeft: isPhone ? '10px' : '15px',
    paddingRight: isPhone ? '10px' : '15px',
    fontSize: '14px',
    textTransform: 'none',
    backgroundColor: 'white',
    color: selected ? '#0675DD' : 'black',
    borderColor: selected ? '#0675DD' : '#D9D9D9',
    whiteSpace: 'nowrap',
    '&:hover': { backgroundColor: 'rgba(243, 245, 247, 0.6)' }
  })
);

export const PrimaryButton = styled(LoadingButton)(
  ({ selected, isPhone }: { selected?: boolean; isPhone?: boolean }) => ({
    paddingLeft: isPhone ? '10px' : '15px',
    paddingRight: isPhone ? '10px' : '15px',
    fontSize: '14px',
    textTransform: 'none',
    backgroundColor: '#0675DD',
    border: 'none',
    color: 'white',
    '&:disabled': {
      backgroundColor: '#c2c2c2',
      color: 'white'
    },
    '&:hover': { backgroundColor: '#267fec', border: 'none' },
    '&.MuiLoadingButton-loading': {
      color: '#c2c2c2',
      '> .MuiLoadingButton-loadingIndicator': {
        color: 'white'
      }
    }
  })
);

export const SecondaryButton = styled(LoadingButton)(
  ({ selected, isPhone }: { selected?: boolean; isPhone?: boolean }) => ({
    paddingLeft: isPhone ? '10px' : '15px',
    paddingRight: isPhone ? '10px' : '15px',
    fontSize: '14px',
    textTransform: 'none',
    color: '#0675DD',
    backgroundColor: '#CEE8FF',
    border: 'none',
    '&:disabled': {
      backgroundColor: '#c2c2c2',
      color: 'white'
    },
    '&:hover': { backgroundColor: '#e8f4ff', border: 'none' },
    '&.MuiLoadingButton-loading': {
      color: '#c2c2c2',
      '> .MuiLoadingButton-loadingIndicator': {
        color: 'white'
      }
    }
  })
);

export const PrimaryLinkButton = styled(LoadingButton)({
  fontSize: '14px',
  display: 'flex',
  color: '#0675DD',
  textTransform: 'none',
  fontWeight: 400,
  padding: 0,
  margin: 0,
  minWidth: 'auto',
  backgroundColor: 'transparent',
  lineHeight: '16px',
  '&:hover': {
    backgroundColor: 'transparent',
    textDecoration: 'underline',
    color: '#267fec'
  },
  '&:focus': {
    outline: 'none'
  }
});
